module.exports = __webpack_public_path__ + "static/img/2.e1e7dd72.jpg";